import Command from "@ckeditor/ckeditor5-core/src/command"
export default class InsertImageWithoutIsbnCommand extends Command {
  execute(options) {
    const model = this.editor.model

    model.change((writer) => {
      model.insertContent(createImageWithoutIsbn(writer, options.source[0]))
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "honcierge-book-without-isbn"
    )

    this.isEnabled = allowedIn !== null
  }
}

function createImageWithoutIsbn(writer, src) {
  const honciergeBookWithoutIsbn = writer.createElement(
    "honcierge-book-without-isbn"
  )
  const articleContainer = writer.createElement("article-container")
  const bookBox = writer.createElement("book-box")
  const bookContent = writer.createElement("book-content")
  const bookTitle = writer.createElement("book-title")
  const bookPublished = writer.createElement("book-published")
  const bookMeta = writer.createElement("book-meta")
  const author = writer.createElement("author")
  const publisher = writer.createElement("publisher")
  const imageElement = writer.createElement("image", { src: src })

  writer.append(articleContainer, honciergeBookWithoutIsbn)
  writer.append(bookBox, articleContainer)
  writer.append(bookContent, bookBox)
  writer.append(bookTitle, bookContent)
  writer.append(bookPublished, bookContent)
  writer.append(bookMeta, bookContent)
  writer.append(author, bookMeta)
  writer.append(publisher, bookMeta)
  writer.append(imageElement, bookBox)

  return honciergeBookWithoutIsbn
}
